import { Grid } from "@mui/material";
import { useCallback, useState } from "react";
import LogTable from "../../components/LogTable/LogTable";
import NavBar from "../../components/NavBar/NavBar";
import LogDataForm from "../../components/LogDataForm/LogDataForm";

const Log = ({ auth, onLogout }) => {

  const [reloadKey, setReloadKey] = useState(0);

  const triggerReload = useCallback(() => {
    setReloadKey(prev => prev + 1);
  }, []);

  return (
    <Grid
      container
      size={{ xs: 12 }}
      rowSpacing={8}
      style={{ width: "100%", margin: 0 }}
    >
      <Grid size={{ xs: 12 }}>
        <NavBar auth={auth} onLogout={onLogout} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <LogDataForm triggerReload={triggerReload} auth={auth} onLogout={onLogout}/>
      </Grid>
      <Grid size={{ xs: 12 }}>
        <LogTable reloadEvent={reloadKey} auth={auth} onLogout={onLogout}/>
      </Grid>
    </Grid>
  );
};

export default Log;